module.exports = __webpack_public_path__ + "assets/img/19.1999dca2.png";